<div class="row">
    <div class="col-12 col-xxl-6 chart-col">
        <div class="detail-page-card">
            <div class="detail-page-card-title">
                {{ 'audit.overviewTitle' | t }}
                {{ totalAudits && totalAudits > 0 ? ('audit.totalCount' | t: { count: totalAudits }) : "" }}
            </div>
            <div class="detail-page-card-body">
                @if (!chartRendered) {
                    <div class="fancy-loader"></div>
                }
                <div class="chart-container" #chart></div>
            </div>
        </div>
    </div>
    <div class="col-12 col-xxl-6 tables">
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="detail-page-card">
                    <div class="detail-page-card-title">
                        {{ 'audit.lastSuccessfulLoginsTitle' | t: { count: audit ? audit.lastSuccessfulLogins.length : 0 } }}
                    </div>
                    <div class="detail-page-card-body">
                        @if (audit) {
                            <ul class="list-group list-group-flush">
                                @if (audit.lastSuccessfulLogins.length === 0) {
                                    <li class="list-group-item">{{ 'audit.noneOccurred' | t }}</li>
                                }
                                @for (date of audit.lastSuccessfulLogins; track date) {
                                    <li class="list-group-item">
                                        {{ date | dateTimeFormat }}
                                    </li>
                                }
                            </ul>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <div class="detail-page-card">
                    <div class="detail-page-card-title">
                        {{ 'audit.lastUnsuccessfulLoginsTitle' | t: { count: audit ? audit.lastUnsuccessfulLogins.length : 0 } }}
                    </div>
                    <div class="detail-page-card-body">
                        @if (audit) {
                            <ul class="list-group list-group-flush">
                                @if (audit.lastUnsuccessfulLogins.length === 0) {
                                    <li class="list-group-item">{{ 'audit.noneOccurred' | t }}</li>
                                }
                                @for (date of audit.lastUnsuccessfulLogins; track date) {
                                    <li class="list-group-item">
                                        {{ date | dateTimeFormat }}
                                    </li>
                                }
                            </ul>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="detail-page-card">
                    <div class="detail-page-card-title">
                        {{ 'audit.lastPasswordResetsTitle' | t: { count: audit ? audit.lastPasswordResets.length : 0 } }}
                    </div>
                    <div class="detail-page-card-body">
                        @if (audit) {
                            <ul class="list-group list-group-flush">
                                @if (audit.lastPasswordResets.length === 0) {
                                    <li class="list-group-item">{{ 'audit.noneOccurred' | t }}</li>
                                }
                                @for (date of audit.lastPasswordResets; track date) {
                                    <li class="list-group-item">
                                        {{ date | dateTimeFormat }}
                                    </li>
                                }
                            </ul>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <div class="detail-page-card">
                    <div class="detail-page-card-title">
                        {{ 'audit.lastPasswordChangesTitle' | t: { count: audit ? audit.lastPasswordChanges.length : 0 } }}
                    </div>
                    <div class="detail-page-card-body">
                        @if (audit) {
                            <ul class="list-group list-group-flush">
                                @if (audit.lastPasswordChanges.length === 0) {
                                    <li class="list-group-item">{{ 'audit.noneOccurred' | t }}</li>
                                }
                                @for (date of audit.lastPasswordChanges; track date) {
                                    <li class="list-group-item">
                                        {{ date | dateTimeFormat }}
                                    </li>
                                }
                            </ul>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
